<template>
  <div
    v-if="product && attributes"
    class="configurable"
  >
    <ProductConfigurableAttribute
      v-for="attribute in attributes"
      :key="`${product.id}_${attribute.attribute_code}`"
      :attribute="attribute"
      :product="product"
      :selected-options="selectedOptions"
      :parent-type="parentType"
      @selected="selected"
    />
  </div>

  <slot
    name="oos"
    v-bind="{ oos }"
  />
</template>

<script lang="ts" setup>
import type {
  MagentoConfigurableProductOptionsValue,
  MagentoConfigurableProductCartItemInput,
  MagentoConfigurableProduct, MagentoConfigurableVariant,
} from '~layers/app/types/magento'

export interface Props {
  product: MagentoConfigurableProduct
  parentType?: string
}

const props = defineProps<Props>()
const emit = defineEmits<{
  selected: Record<string, MagentoConfigurableProductCartItemInput>
}>()

const selectedOptions = ref<Record<string, MagentoConfigurableProductOptionsValue>>({})

const selected = (attributeOption: Record<string, MagentoConfigurableProductOptionsValue | null>) => {
  selectedOptions.value = {
    ...selectedOptions.value,
    ...attributeOption,
  }
  if (!Object.values(selectedOptions.value).some(item => item)) {
    emit('selected', { [props.product.sku]: null })
  }
  else {
    emit('selected', {
      [props.product.sku]: outOfStock.value
        ? null
        : {
            quantity: 1,
            sku: props.product.sku,
            selected_options: Object.values(selectedOptions.value).map(item => item.uid),
          },
    })
  }
}

const selectedVariant = computed<MagentoConfigurableVariant | null>(() =>
  props.product.variants.find((variant: MagentoConfigurableVariant) => {
    let variantAttribute
    for (const attributeCode in selectedOptions.value) {
      variantAttribute = variant.attributes.find((varAttr: any) => varAttr.code === attributeCode)
      if (variantAttribute?.value_index !== selectedOptions.value[attributeCode].value_index) {
        return false
      }
    }
    return !!Object.keys(selectedOptions.value).length
  }) || null,
)

const outOfStock = computed(() =>
  selectedVariant.value?.product?.stock_status === 'OUT_OF_STOCK' || props.product.stock_status === 'OUT_OF_STOCK',
)

const oos = computed(() =>
  outOfStock.value ? [selectedVariant.value?.product || props.product] : [],
)

const attributes = computed(() => {
  return props.product?.configurable_options
})
</script>
